import { DateTimeUtils } from '../../media-player/date-time-utils';
import { Guid } from '../guid';
import { EventKey } from './enums';
import { IEventContext } from './event-context';
import { EventEnvelopData, IEventEnvelop } from './models';

export class EventEnvelop implements IEventEnvelop {

    readonly timestamp: number;

    data: EventEnvelopData;
    sequenceId: number;
    eventType: EventKey;
    context: IEventContext;
    id: string = Guid.v1();

    constructor(eventType: EventKey, data: EventEnvelopData) {
        this.data = data;
        this.id = Guid.v1();
        this.eventType = eventType;
        this.timestamp = DateTimeUtils.UTCNow;
        if (data) {
            this.data = {type: eventType, ...data};
        } else {
            this.data = null;
        }
    }

}
